import React from 'react'

import { RawHtmlSection as Props } from '../../../../types/graphql'

import { Body } from './styles'
import { extractScripts } from './utils'

export const RawHtmlSection: React.FC<Props> = ({ html }) => {
  const { htmlWithoutScripts, scriptTexts } = extractScripts(html)

  React.useEffect(() => {
    scriptTexts.forEach(text => {
      const node = document.createElement('script')
      node.innerText = text
      document.body.appendChild(node)
    })
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Body dangerouslySetInnerHTML={{ __html: htmlWithoutScripts }} />
}
